/**
 * @copyright Elmelo Ltd.
 */

/**
 *  Password kept in memory between sign up / sign in and email verification, so the user
 *  can be signed in after verifying. Never put it in router (history) state: that is
 *  saved by the browser and readable by any script on the page.
 */
let _password = null;

export const SetPendingPassword = password => {
	_password = password || null;
};

/**
 *  Returns the password once and forgets it.
 */
export const TakePendingPassword = () => {
	const password = _password;
	_password = null;
	return password;
};
